import AdvancedTokenOffer from "./MeterOverview/AdvancedTokenOffer";
import ChargeGroup from "./MeterOverview/ChargeGroup";
import MinimumVendNotice from "./MeterOverview/MinimumVendNotice";
import { useNavigate, useParams } from "react-router-dom";
import LastVends from "./MeterOverview/LastVends";
import Button from "components/Button";
import Collections from "./MeterOverview/Collections";
import PageTitle from "components/PageTitle";
import Page from "components/Page";
import { MeterOverviewResponse } from "./MeterOverview/models";
import useFetch from "hooks/use-fetch";
import { rememberMeter } from "cookies";
import { useEffect } from "react";
import { HomePageWithError } from "./Home";

export default function MeterOverviewPage() {
    const { meterNumber } = useParams();
    const nav = useNavigate();
    const { data, loading, error } = useFetch<MeterOverviewResponse>(`/api/v1/meters/${meterNumber}`);

    useEffect(() => {
        if (data && meterNumber) {
            rememberMeter(meterNumber);
        }
    }, [data, meterNumber]);

    if (!meterNumber) {
        return <div className="p-4 text-center">No meter found defined</div>;
    }

    if (!loading && error) {
        return <HomePageWithError meterNumber={meterNumber} error="Meter not found" />;
    }

    return (
        <Page align="left">
            <PageTitle>{meterNumber}</PageTitle>
            {loading && <div className="text-sm text-gray-600">Loading meter information...</div>}
            {!loading && data && (
                <div className="space-y-4 text-sm sm:text-base">
                    <MinimumVendNotice
                        minimumVendAmount={data.minimumVendAmount}
                        hasCollections={data.collections.length > 0}
                        collectionTotal={data.collectionTotal}
                    />

                    <Collections collections={data.collections} collectionTotal={data.collectionTotal} />
                    <AdvancedTokenOffer meterNumber={meterNumber} advancedToken={data.advancedToken} />
                    <ChargeGroup currentUsage={data.periodUsage} chargeGroup={data.chargeGroup} />
                    <LastVends vends={data.recentVends} />

                    <Button className="w-full sm:w-48 mx-auto block" onClick={() => nav("/")}>Done</Button>
                </div>
            )}
        </Page>
    );
}
